var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "pb-12"
  }, [_c('h1', {
    staticClass: "my-6 text-h4 text-sm-h3"
  }, [_vm._v("Cookies")]), _c('p', [_vm._v("This website may store information on your computer in the form of \"cookies\". You can update your preferences for this browser at the "), _c('a', {
    attrs: {
      "href": "#preferences"
    }
  }, [_vm._v("bottom of this page")]), _vm._v(". ")]), _c('p', [_vm._v("We use cookies to help you personalize your online experience. A cookie is a text file that is placed on your hard disk by a web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a web server in the domain that issued the cookie to you.")]), _c('p', [_vm._v("You have the ability to accept or decline cookies. Most Web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. If you choose to decline cookies, you may not be able to fully experience the interactive features of Ellacard. Please see our "), _c('a', {
    attrs: {
      "href": "/privacy-policy"
    }
  }, [_vm._v("privacy policy")]), _vm._v(" for more information.")]), _c('p', [_vm._v("Ellacard may store information on your computer for the following purposes:")]), _c('div', {
    staticClass: "overline"
  }, [_vm._v("Basic functionality")]), _c('p', [_vm._v("To remember your account")]), _c('div', {
    staticClass: "overline"
  }, [_vm._v("Performance")]), _c('p', [_vm._v("To collect aggregated, anonymized usage / performance data via Google Analytics")]), _c('div', {
    staticClass: "overline"
  }, [_vm._v("Targeting")]), _c('p', [_vm._v("To track ad performance and conversions and enable targeted ads on other sites via Google Analytics and Facebook")]), _c('div', {
    staticClass: "overline"
  }, [_vm._v("Other (third-party services)")]), _c('p', [_vm._v("To provide additional features from third-party services: "), _c('ul', [_c('li', [_vm._v("Facebook — for signing in")]), _c('li', [_vm._v("Giphy — animated GIF and sticker library")]), _c('li', [_vm._v("Google — for signing in")])])]), _c('h1', {
    staticClass: "mt-12 mb-6 text-h5 text-sm-h4",
    attrs: {
      "id": "preferences"
    }
  }, [_vm._v("Preferences")]), _vm.disabled ? _c('div', {
    staticClass: "error--text font-italic mb-6"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "error"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v("Cookies have been disabled at the browser level. Some parts of the site may not work.")], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-switch', {
    staticClass: "mt-n1",
    attrs: {
      "disabled": "",
      "hide-details": ""
    },
    model: {
      value: _vm.scope.strict,
      callback: function ($$v) {
        _vm.$set(_vm.scope, "strict", $$v);
      },
      expression: "scope.strict"
    }
  }), _c('div', {
    staticClass: "overline mr-2"
  }, [_vm._v("Strictly necessary")]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiHelpCircle)
    },
    on: {
      "click": function ($event) {
        return _vm.$confirm({
          title: 'Strictly necessary',
          msg: `These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences or signing in. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work.`,
          buttons: ['Ok'],
          primary: 'Ok',
          persistent: false
        });
      }
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-switch', {
    staticClass: "mt-n1",
    attrs: {
      "disabled": _vm.disabled,
      "hide-details": ""
    },
    model: {
      value: _vm.scope.performance,
      callback: function ($$v) {
        _vm.$set(_vm.scope, "performance", $$v);
      },
      expression: "scope.performance"
    }
  }), _c('div', {
    staticClass: "overline mr-2"
  }, [_vm._v("Performance cookies")]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiHelpCircle)
    },
    on: {
      "click": function ($event) {
        return _vm.$confirm({
          title: 'Performance cookies',
          msg: `These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.`,
          buttons: ['Ok'],
          primary: 'Ok',
          persistent: false
        });
      }
    }
  })], 1), _c('div', {
    staticClass: "mb-6 d-flex align-center"
  }, [_c('v-switch', {
    staticClass: "mt-n1",
    attrs: {
      "disabled": _vm.disabled,
      "hide-details": ""
    },
    model: {
      value: _vm.scope.targeting,
      callback: function ($$v) {
        _vm.$set(_vm.scope, "targeting", $$v);
      },
      expression: "scope.targeting"
    }
  }), _c('div', {
    staticClass: "overline mr-2"
  }, [_vm._v("Targeting cookies")]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiHelpCircle)
    },
    on: {
      "click": function ($event) {
        return _vm.$confirm({
          title: 'Targeting cookies',
          msg: `These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.`,
          buttons: ['Ok'],
          primary: 'Ok',
          persistent: false
        });
      }
    }
  })], 1), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "disabled": !_vm.canUpdate
    },
    on: {
      "click": _vm.udpateCookies
    }
  }, [_vm._v(_vm._s(_vm.global.cookies ? 'Update' : 'Accept'))])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }